import { Button, Modal, ModalBody, ModalHeader } from "flowbite-react";
import type { FC } from "react";
import { useState } from "react";
import { HiOutlineExclamationCircle, HiTrash } from "react-icons/hi";
import type { CommissionLevel } from "../../../types/commission-level";
import { deleteCommissionLevel } from "../../../services/commission-levels";

interface DeleteCommissionLevelModalProps {
  level: CommissionLevel;
  onUpdate: () => Promise<void>;
}

export const DeleteCommissionLevelModal: FC<DeleteCommissionLevelModalProps> = function ({
  level,
  onUpdate,
}) {
  const [isOpen, setOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleDelete = async () => {
    try {
      setIsProcessing(true);
      await deleteCommissionLevel(level.id);
      await onUpdate();
      setOpen(false);
    } catch (error) {
      console.error("Failed to delete commission level:", error);
      alert("Fehler beim Löschen. Möglicherweise wird dieses Level noch verwendet.");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <>
      <Button color="failure" size="sm" onClick={() => setOpen(true)}>
        <HiTrash className="mr-2 text-lg" />
        Löschen
      </Button>
      <Modal onClose={() => setOpen(false)} show={isOpen} size="md">
        <ModalHeader className="px-6 pt-6 pb-0">
          <span className="sr-only">Löschen bestätigen</span>
        </ModalHeader>
        <ModalBody className="px-6 pt-0 pb-6">
          <div className="flex flex-col items-center gap-y-6 text-center">
            <HiOutlineExclamationCircle className="text-7xl text-red-500" />
            <p className="text-xl text-gray-500">
              Sind Sie sicher, dass Sie das Level <strong>{level.level_number} - {level.description}</strong> löschen möchten?
            </p>
            <div className="flex items-center gap-x-3">
              <Button color="failure" onClick={handleDelete} disabled={isProcessing}>
                Ja, löschen
              </Button>
              <Button color="gray" onClick={() => setOpen(false)}>
                Abbrechen
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
